<template>
  <v-container class="container-content">
    <form @keyup.enter.prevent="onSubmit()">
      <AppHeader header-class="col-12 col-md-8">{{
        $t("signin:newpassword.heading2", "Set new password", "Pass heading 2")
      }}</AppHeader>

      <AppShowFeedback ref="showFeedback" />

      <div class="col-xs-12 col-md-8">
        <p>
          {{
            $t(
              "signin:newpassword.heading",
              "Please choose new password.",
              "Pass heading"
            )
          }}
          <br />
          {{
            $t(
              "signin:newpassword.instructions",
              "The password should be at least 8 characters long, contain small and capitalized letters and have one specific symbol.",
              "Pass instructions"
            )
          }}
        </p>
        <div class="col-12 col-md-6 px-0">
          <v-text-field
            v-model="form.password"
            :error-messages="validationErrors('password')"
            type="password"
            class="mobile-max-width"
            :label="
              $t('signin:newpassword.label1', 'New password', 'Pass label')
            "
            outlined
            @blur="v$.form.password.$touch()"
          />
          <v-text-field
            v-model="form.passwordConfirmation"
            :error-messages="validationErrors('passwordConfirmation')"
            type="password"
            class="mobile-max-width"
            :label="
              $t(
                'signin:newpassword.label2',
                'New password confirmation',
                'Pass label'
              )
            "
            outlined
            @blur="v$.form.passwordConfirmation.$touch()"
          />
        </div>
        <AppBtnsRow>
          <template #left="{ attributes }">
            <v-btn
              :to="{
                name: 'PersonProfilePage',
                params: { personId: personId }
              }"
              :disabled="loading"
              v-bind="attributes"
              >{{
                $t("common:button.cancel", "Cancel", "Cancel button")
              }}</v-btn
            >
          </template>
          <template #right="{ attributes }">
            <v-btn
              v-bind="attributes"
              color="accent"
              :loading="loading"
              :disabled="loading"
              @click="onSubmit()"
              >{{ $t("common:button.save", "Save", "Save button") }}</v-btn
            >
          </template>
        </AppBtnsRow>
      </div>
    </form>
  </v-container>
</template>

<script>
import gql from "fraql";
import appFormMixin from "@/mixins/appFormMixin";

import AppShowFeedback from "@AppShows/AppShowFeedback.vue";
import AppHeader from "@elements/AppHeader.vue";
import AppBtnsRow from "@elements/globals/AppBtnsRow.vue";
import FipaListener from "@/utils/listenerUtility";
import Cookies from "js-cookie";

export default {
  name: "PersonResetPassword",
  components: { AppHeader, AppShowFeedback, AppBtnsRow },
  mixins: [appFormMixin],
  props: {
    personId: {
      type: String,
      required: true
    }
  },
  setup() {
    return {
      ...appFormMixin.setup()
    };
  },
  data() {
    return {
      person: {
        id: this.personId
      },
      form: {
        password: null,
        passwordConfirmation: null
      },
      loading: false,
      appFormMixinValidationsConfVariable: "initForm.vuelidateValidations",
      appFormMixinReadOnlyFieldsVariable: "initForm.readOnlyFields",
      initForm: {
        vuelidateValidations: {
          password: { required: true, minLength: 8 },
          passwordConfirmation: {
            required: true,
            sameAsPassword: "password"
          }
        },
        readOnlyFields: []
      }
    };
  },
  apollo: {
    person: {
      query: gql`
        query person($id: ID!) {
          person(id: $id) {
            id
            name
          }
        }
      `,
      variables() {
        return {
          id: this.personId
        };
      },
      manual: true,
      result({ data }) {
        if (data && data.person) {
          FipaListener.emit("breadcrumbPageName", {
            name: data.person.name,
            id: data.person.id,
            breadcrumbName: "personName"
          });
        }
      },
      fetchPolicy: "cache-first"
    }
  },
  methods: {
    validationErrors(fieldName) {
      return this.appFormMixinValidationErrorsForField(fieldName);
    },
    async onSubmit() {
      this.$refs.showFeedback.close();
      this.v$.form.$touch();
      if (this.v$.form.$invalid) {
        this.$refs.showFeedback.open("warn");
        return;
      }

      this.loading = true;

      try {
        const params1 = new URLSearchParams(location.search);
        const authToken = Cookies.get("token") || params1.get("auth_token");
        await this.$apollo.mutate({
          mutation: gql`
            mutation personSetPassword(
              $id: ID
              $password: String
              $passwordConfirmation: String
              $authToken: String
            ) {
              personSetPassword(
                input: {
                  id: $id
                  password: $password
                  passwordConfirmation: $passwordConfirmation
                  authToken: $authToken
                }
              ) {
                person {
                  id
                }
              }
            }
          `,
          variables: {
            id: this.personId,
            password: this.form.password,
            passwordConfirmation: this.form.passwordConfirmation,
            authToken
          }
        });

        this.$root.$snackbar("success", {
          redirection: true
        });
        this.$router.push({
          name: "PersonProfilePage",
          params: { personId: this.personId }
        });
      } catch (error) {
        this.$root.$snackbarServerError(error, { level: "error" });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
